/**
 * Тип документа, удостоверяющего личность
 *
 * @see https://ofd.ru/razrabotchikam/ferma#%D0%B2%D0%BE%D0%B7%D0%BC%D0%BE%D0%B6%D0%BD%D1%8B%D0%B5_%D0%B7%D0%BD%D0%B0%D1%87%D0%B5%D0%BD%D0%B8%D1%8F_%D0%BF%D0%B0%D1%80%D0%B0%D0%BC%D0%B5%D1%82%D1%80%D0%B0_iddoctype
 */
export enum IdDocumentType {
	/** Паспорт гражданина Российской Федерации */
	RfId = "RF_ID",

	/** Паспорт гражданина Российской Федерации, дипломатический паспорт, служебный паспорт, удостоверяющие личность гражданина Российской Федерации за пределами Российской Федерации */
	RfIdEtc = "RF_ID_ETC",

	/** Временное удостоверение личности гражданина Российской Федерации, выдаваемое на период оформления паспорта гражданина Российской Федерации */
	TempRfId = "TEMP_RF_ID",

	/** Свидетельство о рождении гражданина Российской Федерации (для граждан Российской Федерации в возрасте до 14 лет) */
	BirthRfId = "BIRTH_RF_ID",

	/** Иные документы, признаваемые документами, удостоверяющими личность гражданина Российской Федерации в соответствии с законодательством Российской Федерации */
	OtherRfId = "OTHER_RF_ID",

	/** Паспорт иностранного гражданина */
	ForeignId = "FOREIGN_ID",

	/** Иные документы, признаваемые документами, удостоверяющими личность иностранного гражданина в соответствии с законодательством Российской Федерации и международным договором Российской Федерации */
	ForeignIdOther = "FOREIGN_ID_OTHER",

	/** Документ, выданный иностранным государством и признаваемый в соответствии с международным договором Российской Федерации в качестве документа, удостоверяющего личность лица без гражданства. */
	IdForeignStateless = "ID_FOREIGN_STATELESS",

	/** Вид на жительство (для лиц без гражданства) */
	ResidencePermit = "RESIDENCE_PERMIT",

	/** Разрешение на временное проживание (для лиц без гражданства) */
	TempResidencePermit = "TEMP_RESIDENCE_PERMIT",

	/** Свидетельство о рассмотрении ходатайства о признании лица без гражданства беженцем на территории Российской Федерации по существу */
	StatelessReviewId = "STATELESS_REVIEW_ID",

	/** Удостоверение беженца */
	RefugeeId = "REFUGEE_ID",

	/** Иные документы, признаваемые документами, удостоверяющими личность лиц без гражданства в соответствии с законодательством Российской Федерации и международным договором Российской Федерации */
	OtherId = "OTHER_ID",

	/** Документ, удостоверяющий личность лица, не имеющего действительного документа, удостоверяющего личность, на период рассмотрения заявления о признании гражданином Российской Федерации или о приеме в гражданство Российской Федерации */
	StatelessReviewRfId = "STATELESS_REVIEW_RF_ID",
}
